import React, { useEffect, useState, useRef } from "react";
import "../assets/css/style.css";
import { registrarAnalyticsOferta } from "../api";

const OfferBottomSheet = ({ offer, visible, onClose }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  const [shouldRender, setShouldRender] = useState(false); 
  const sheetRef = useRef(null);

  useEffect(() => {
    if (visible && offer) {
      setShouldRender(true);
      setTimeout(() => setIsOpen(true), 20);
      setIsClosing(false);
    } else if (!visible && isOpen) {
      setIsClosing(true);
    }
  }, [visible, offer]);

  useEffect(() => {
    if (visible && offer?.id_oferta) {
      const user = JSON.parse(localStorage.getItem("userData") || "null");
      const lat = localStorage.getItem("userLat");
      const lang = localStorage.getItem("userLng");
      registrarAnalyticsOferta(offer.id_oferta, user?.id || null, lat, lang);
    }
  }, [visible]);

  useEffect(() => {
    if (isClosing) {
      setTimeout(() => {
        setShouldRender(false);
        setIsOpen(false); 
        setIsClosing(false);
        onClose();
      }, 400);
    }
  }, [isClosing, onClose]);

  if (!shouldRender) return null;

  return (
    <>
      <div
        className={`overlay ${visible ? "active" : ""}`}
        onClick={() => setIsClosing(true)}
      ></div>
      <div
        ref={sheetRef}
        className={`offer-bottom-sheet ${isOpen ? "open" : ""} ${
          isClosing ? "closing" : ""
        }`}
        onTransitionEnd={() => {
          if (isClosing) {
            setShouldRender(false);
          }
        }}
      >
        {offer && (
          <div className="offer-sheet-content">
            <div className="close-offer">
              <span onClick={() => setIsClosing(true)}>
                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 24 24">
                    <path fill="currentColor" d="m12 13.4l-4.9 4.9q-.275.275-.7.275t-.7-.275t-.275-.7t.275-.7l4.9-4.9l-4.9-4.9q-.275-.275-.275-.7t.275-.7t.7-.275t.7.275l4.9 4.9l4.9-4.9q.275-.275.7-.275t.7.275t.275.7t-.275.7L13.4 12l4.9 4.9q.275.275.275.7t-.275.7t-.7.275t-.7-.275z"></path>
                </svg>
              </span>
            </div>
            <img className="offer-logo-large" id="offerLogo" src={offer.logo} alt="Logo" />
            <h3 id="offerBusinessName">
                {offer.businessName}
                <img src="/assets/images/verified.svg" className="verifiedUser" style={{ width: 300 }} alt="Verificado" />
            </h3>
            <h2 id="offerTitle">{offer.title}</h2>
            <p id="offerDescription">{offer.description}</p>
            <p className="offer-expiry" id="offerExpiry">{offer.expiry}</p>
          </div>
        )}
      </div>
    </>
  );
};

export default OfferBottomSheet;
